// Mirror of foundation/users/src/policies/CustomerLevelPolicy.js
//
// Client-side copy of the customer-level constants so React
// components can render pills without a round-trip. The server is
// the source of truth for thresholds and derivation; this file
// only holds the name/order/visual treatment.

export const CUSTOMER_LEVELS = [
  { name: 'guest',   label: 'Guest',   rung: 0, persistable: false },
  { name: 'free',    label: 'Member',  rung: 1, persistable: true },
  { name: 'paid',    label: 'Customer', rung: 2, persistable: true },
  { name: 'premium', label: 'Premium', rung: 3, persistable: true },
  { name: 'vip',     label: 'VIP',     rung: 4, persistable: true },
  { name: 'vvip',    label: 'VVIP',    rung: 5, persistable: true }
];

export const PERSISTABLE_CUSTOMER_LEVELS = CUSTOMER_LEVELS
  .filter((l) => l.persistable)
  .map((l) => l.name);

// Higher rung = warmer / more saturated treatment, so an operator
// scanning a list spots VVIP customers immediately.
export const CUSTOMER_LEVEL_COLOR = {
  guest:   'bg-gray-100 text-gray-700 border-gray-200',
  free:    'bg-blue-50 text-blue-700 border-blue-200',
  paid:    'bg-emerald-50 text-emerald-700 border-emerald-200',
  premium: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  vip:     'bg-amber-100 text-amber-800 border-amber-300',
  vvip:    'bg-rose-100 text-rose-800 border-rose-300'
};

// Available admin tags an operator can stamp. Keep aligned with
// foundation/users/src/policies/CustomerLevelPolicy.js#CUSTOMER_LEVEL_ADMIN_TAGS.
export const CUSTOMER_LEVEL_ADMIN_TAGS = [
  'standard',
  'premium',
  'vip',
  'vvip',
  'strategic',
  'design_partner'
];

export const colorForCustomerLevel = (name) =>
  CUSTOMER_LEVEL_COLOR[name] || CUSTOMER_LEVEL_COLOR.free;

export const labelForCustomerLevel = (name) => {
  const entry = CUSTOMER_LEVELS.find((l) => l.name === name);
  return entry ? entry.label : 'Free';
};

export const rungForCustomerLevel = (name) => {
  const entry = CUSTOMER_LEVELS.find((l) => l.name === name);
  return entry ? entry.rung : null;
};

export default {
  CUSTOMER_LEVELS,
  PERSISTABLE_CUSTOMER_LEVELS,
  CUSTOMER_LEVEL_COLOR,
  CUSTOMER_LEVEL_ADMIN_TAGS,
  colorForCustomerLevel,
  labelForCustomerLevel,
  rungForCustomerLevel
};
